import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Optional,
  Inject,
  AfterViewInit,
  PLATFORM_ID,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, Observable, BehaviorSubject } from "rxjs";
import { IEvent, IRepeatEvent } from "src/app/shared/interfaces";
import { environment } from "src/environments/environment";
import { faTrain, faBus, faSubway, faMousePointer } from "@fortawesome/pro-light-svg-icons";
import { faMapMarkerAlt, faCalendar } from "@fortawesome/pro-duotone-svg-icons";
import { faFacebookF, faInstagram, faTwitter, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { SeoService } from "src/app/shared/services/seo.service";
import { TwoDatesFormat } from "src/app/shared/pipes/two-dates.pipe";
import { DaysOfWeekPipe } from "src/app/shared/pipes/day-of-week.pipe";
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { CategoriesService } from "src/app/shared/services/categories.service";
import { RESPONSE } from "@nguniversal/express-engine/tokens";
import { Response } from 'express'
import { isPlatformServer } from "@angular/common";
import { GraphResponse } from "src/app/core/services/store.service";
import { map } from "rxjs/operators";
import { SearchService } from "src/app/shared/services/search.service";
// import 'https://ping-culture.com/embed-ticket.js';
// open widgets button from our booking widget
declare var PingCultureTickets: any;

@Component({
  selector: "ping-event-page",
  templateUrl: "./event-page.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./event-page.component.scss"],
})
export class EventPageComponent implements OnInit {
  private $destroy = new Subject();

  public event$ = new BehaviorSubject<any>(null);
  public moreEvents$: Observable<IEvent[]>;
  public $promoter: Observable<any>;
  public imagePrefix: string = environment.aws.s3Url + 'events/';
  public fallbackImageBlurred: string;
  public fallbackImage: string;
  public logoPrefix: string = environment.aws.s3Url + "logo/200/";
  public currentTimeline: any;

  public faMapMarker = faMapMarkerAlt;
  // public faCalendar = faCalendar;
  public faChevronRight = faChevronRight;
  faTrain = faTrain;
  faSubway = faSubway;
  faBus = faBus;

  faFacebook = faFacebookF;
  faTiktok = faTiktok;
  faMousePointer = faMousePointer;
  faInstagram = faInstagram;
  faTwitter = faTwitter;

  public buyTicketWidgetUrl: string;

  public categories: string[];


  zoom = 12;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    mapTypeId: "roadmap",
    zoomControl: true,
    panControl: true,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: false,
    styles: [
      {
        elementType: "geometry",
        stylers: [
          {
            color: "#f4f5f4",
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#f5f5f5",
          },
        ],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#b5b5b5",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#e5e5e5",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#757575",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [
          {
            color: "#dadada",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#616161",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
      {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [
          {
            color: "#e5e5e5",
          },
        ],
      },
      {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#c9c9c9",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#9e9e9e",
          },
        ],
      },
    ],
    maxZoom: 15,

    minZoom: 8,
  };

  marker: any;
  private response: Response;
  public deviceWidth: number = 1920;

  public noTimelineImages: boolean;

  constructor(
    private cd: ChangeDetectorRef,
    private seoService: SeoService,
    private twoDatesPipe: TwoDatesFormat,
    private dayOfWeekPipe: DaysOfWeekPipe,
    private route: ActivatedRoute,
    private utils: UtilitiesService,
    private categoryService: CategoriesService,
    @Inject(PLATFORM_ID) private platformId,
    private router: Router,
    private searchService: SearchService,
    @Optional() @Inject(RESPONSE) response: any
  ) {
    this.response = response;
  }

  ngOnInit(): void {
    this.deviceWidth = window && window?.innerWidth < 768 ? 800 : 1920;
    if (window?.scroll) {
      window.scroll(0, 0);
    }
    const e: any = this.route.snapshot.data['eventData'];
    this.init(e);
  }

  ngOnDestroy() {
    this.$destroy.next(null);
  }

  private async init(event: any): Promise<void> {
    if (event.status === 'DELETED') {
      this.router.navigate(['/events?not-found=true']);
      if (this.response) {
        this.response.status(404);
      }
      return;
    }
    this.applySEO(event);
    this.marker = {
      position: { lat: event.location.lat, lng: event.location.lon },
      icon: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
      title: event.entity?.title || event.address?.addressLine1,
      options: { animation: google.maps.Animation.BOUNCE },
    };

    if (event?.timelines?.length) {
      if (event?.timelines?.length > 1) {
        this.currentTimeline = event.timelines[0];
      }

      if (!event?.timelines.some(t => t.timeslots?.length && t.timeslots.some(s => s.image))) {
        this.noTimelineImages = true;
      }
    }

    // get category image as fallback ifevent has no image
    if (!event?.images?.length) {
      this.fallbackImageBlurred = await this.categoryService.fallbackCategoryImage(event, 100);
      this.fallbackImage = await this.categoryService.fallbackCategoryImage(event, 1920);
    }
    if (event?.config?.canBuyTickets) {
      this.buyTicketWidgetUrl = `https://bookings.ping-culture.com/ticket?event_id=${event.id}&type=${event.type}`;
    }
    // if (!isPlatformServer(this.platformId)) {
      this.utils.stopSpinner();
    // }
    this.event$.next(event)

    this.moreEvents$ = this.searchService.getEventsBySearch(null, event.city, 4, null)
    .pipe(map((res: GraphResponse) => res?.items?.filter((e: IEvent) => e.id !== event.id)))

  }

  private applySEO(event: IEvent | IRepeatEvent | any) {

    const dates: string = event?.startDate
      ? this.twoDatesPipe.transform(event.startDate, event.endDate)
      : `${this.dayOfWeekPipe.transform(event.daysOfWeek)} ${event.startTime}-${event.endTime
      }`;
    this.seoService.updateMeta(
      `${event.title}${event.entity ? " at " + event.entity.title : ""}, ${event.city
      } - Ping Culture`,
      `${dates} - ${event.entity?.title ? event.entity.title + ' - ' : ''}${event.description ? event.description + '. ' : ''}Full live-updating lineups, tickets, artist info, and directions.`,
      this.router?.url || null,
      event.images?.length ? this.imagePrefix + event.images[0] : null
    );

    this.seoService.createLinkForCanonicalURL(`https://ping-culture.com/events/${event.username ? 'event/' + event.type + '/' + event.username : 'type/' + event.type + '/' + event.username}`);
  }

  public setTimeline(timeline: any): void {
    this.currentTimeline = timeline;
    this.cd.detectChanges();
  }

  public goToPage(id: string, type: string): void {
    this.router.navigate(["events", type, id]);
  }

  public openTicketWidgetModal(event) {
    new PingCultureTickets.init({eventId: event.id, eventType: event.type});
  }

}
